module.exports = __webpack_public_path__ + "img/logo3.bb9ffe23.png";